import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import './index.less';
import SignTypeList from './signTypeList';
import PaymentTypeList from './paymentTypeList';

const SignAndPayment = () => {
  // tabs
  const tabItems: TabsProps['items'] = [
    {
      key: 'signTypeList',
      label: `签约平台`,
      children: <SignTypeList />,
    },
    {
      key: 'paymentTypeList',
      label: `支付类型`,
      children: <PaymentTypeList />,
    },
  ];

  return (
    <div>
      <Tabs className="tabContainer" defaultActiveKey="signTypeList" items={tabItems} />
    </div>
  );
};
export default SignAndPayment;
